<ng-container *appFilesAppContext>
<div class="files-shell">
  <app-collapsible-rail-shell class="files-rail" [app]="app" [prototypeHeaderNames]="true">
    <stch-side-bar-teams
      *stchSpaceRerender
      [template]="sidebarTemplate"
      [splitViewKey]="sidebarSplitViewKey.files"
    />
  </app-collapsible-rail-shell>

  <app-split-view
    class="files-rest"
    side="left"
    key="filesList"
    [collapsedSize]="25"
    [shadow]="true"
    [magneticSize]="300"
    [withIcon]="true"
    [iconTop]="38"
  >
    <app-files-list-container
      split-left-pane
      *stchSpaceRerender
      class="list shadow-lg"
    />

    <div class="full-form shadow-lg" split-right-pane *stchSpaceRerender>
      <app-files-main-view />
    </div>
  </app-split-view>

  <ng-template #sidebarTemplate let-team="team">
    <app-files-side-bar [team]="team"/>
  </ng-template>
</div>
</ng-container>
